import { useState, useCallback, memo } from "react";
import { IconButton, Badge, Tooltip } from "@mui/material";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { usePendingActions } from "../context/pendingActionsContext";
import PendingActionsDrawer from "./PendingActionsDrawer";

const PendingActionsButton = () => {
  const { pendingCount } = usePendingActions();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleOpenDrawer = useCallback(() => {
    setDrawerOpen(true);
  }, []);

  const handleCloseDrawer = useCallback(() => {
    setDrawerOpen(false);
  }, []);

  if (pendingCount === 0) {
    return null;
  }

  const tooltipText = pendingCount === 1 ? "1 pending action" : `${pendingCount} pending actions`;

  return (
    <>
      <Tooltip title={tooltipText}>
        <IconButton
          onClick={handleOpenDrawer}
          sx={{
            color: "white",
            mr: 1,
          }}
        >
          <Badge badgeContent={pendingCount} color="warning" max={99}>
            <HourglassEmptyIcon />
          </Badge>
        </IconButton>
      </Tooltip>
      <PendingActionsDrawer open={drawerOpen} onClose={handleCloseDrawer} />
    </>
  );
};

export default memo(PendingActionsButton);
